export enum ProgressStatus {
  NOTYETSTARTED = 1,
  COMPLETED = 2,
  INPROGRESS = 3,
  NOTMAPPED = 4,
  DELAYED = 5,
  DELAYEDCOMPLETED = 6,
  DELAYEDINPROGRESS = 7,
  DELAYEDNOTYETSTARTED = 8,
  PRODUCTIONPLANNED = 9,
  DELIVARYPLANNED = 10,
  ERECTIONPLANNED = 11,
  NOTYETPLANNED = 12,
  PRODUCTIONCOMPLETED = 13,
  CONSTRUCTIONACTUAL = 14,
  PRODUCTIONYETTOSTART = 15,
  INVENTORY = 16,
  REJECTION = 17
}

export const progressStatusEnumMap: {
  [key in ProgressStatus]: string;
} = {
  [ProgressStatus.NOTYETSTARTED]: 'Yet to Started',
  [ProgressStatus.COMPLETED]: 'Completed',
  [ProgressStatus.INPROGRESS]: 'InProgress',
  [ProgressStatus.DELAYED]: 'Delayed',
  [ProgressStatus.NOTMAPPED]: 'Not Mapped',
  [ProgressStatus.DELAYEDCOMPLETED]: 'Delayed Completed',
  [ProgressStatus.DELAYEDINPROGRESS]: 'Delayed InProgress',
  [ProgressStatus.DELAYEDNOTYETSTARTED]: 'Delayed Yet to Started',
  [ProgressStatus.PRODUCTIONPLANNED]: 'Production Planned',
  [ProgressStatus.DELIVARYPLANNED]: 'Delivery Planned',
  [ProgressStatus.ERECTIONPLANNED]: 'Erection Planned',
  [ProgressStatus.NOTYETPLANNED]: 'Not yet Planned',
  [ProgressStatus.PRODUCTIONCOMPLETED]: 'Production Completed',
  [ProgressStatus.CONSTRUCTIONACTUAL]: 'Construction Actual',
  [ProgressStatus.PRODUCTIONYETTOSTART]: 'Production Yet to Start',
  [ProgressStatus.INVENTORY]: 'Inventory',
  [ProgressStatus.REJECTION]: 'Rejection'
};

export enum ProgressUpdateStatus {
  NOTYETSTARTED = 1,
  COMPLETED = 2,
  INPROGRESS = 3,
  REJECTION = 17
}

export const progressUpdateStatusEnumMap: {
  [key in ProgressUpdateStatus]: string;
} = {
  [ProgressStatus.NOTYETSTARTED]: 'Not yet started',
  [ProgressStatus.COMPLETED]: 'Completed',
  [ProgressStatus.INPROGRESS]: 'InProgress',
  [ProgressStatus.REJECTION]: 'Rejection'
};
